import type { DeviceMapping, DeviceMappingListQuery } from '@chukua/common';
import { Button, Popconfirm, Tag, type TableColumnsType } from 'antd';
import type { ListQueryControls } from '../../../../../shared/hooks/use-list-query';

interface BuildDeviceMappingColumnsArgs {
  list: Pick<ListQueryControls<DeviceMappingListQuery>, 'sortOrderFor'>;
  onEnd: (mapping: DeviceMapping) => void;
}

const formatInstant = (instant: string) => new Date(instant).toLocaleString();

export function buildDeviceMappingColumns({ list, onEnd }: BuildDeviceMappingColumnsArgs): TableColumnsType<DeviceMapping> {
  return [
    {
      title: 'Device',
      dataIndex: 'deviceId',
      key: 'deviceId',
      sorter: true,
      sortOrder: list.sortOrderFor('deviceId'),
      render: (id: string) => <code>{id}</code>,
    },
    { title: 'Truck', dataIndex: 'truckRegistration', key: 'truck' },
    {
      title: 'From',
      key: 'effectiveFrom',
      sorter: true,
      sortOrder: list.sortOrderFor('effectiveFrom'),
      render: (_, mapping) => formatInstant(mapping.effectiveFrom),
    },
    {
      title: 'Until',
      key: 'effectiveTo',
      render: (_, mapping) => (mapping.effectiveTo ? formatInstant(mapping.effectiveTo) : <Tag color="success">Current</Tag>),
    },
    {
      title: '',
      key: 'actions',
      render: (_, mapping) =>
        mapping.effectiveTo === null ? (
          <Popconfirm
            title={`End ${mapping.deviceId} on ${mapping.truckRegistration}?`}
            description="Positions from this device stop counting for the truck from now."
            okText="End mapping"
            onConfirm={() => onEnd(mapping)}
          >
            <Button size="small">End</Button>
          </Popconfirm>
        ) : null,
    },
  ];
}
